"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = require("../SvgIcon");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} /**
  * This file was generated by the build:icons script
  * See Notion for details on how to add icons
  */
const PhoneIcon = props => /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.262 16.228c.262.026.492-.033.667-.208.746-.746 1.115-1.115 1.593-.956.324.108.853.227 1.359.34.488.109.954.213 1.19.298.44.158.637.424.637.637v2.549c0 .51-.425.637-.637.637-1.041.07-3.142-.197-5.47-1.384a14.93 14.93 0 0 1-3.77-2.758c-1.155-1.155-1.99-2.288-2.592-3.345-1.61-2.822-1.565-5.098-1.552-5.774l.002-.12c0-.51.425-.638.637-.638h2.55c.198 0 .488.193.636.637.213.638.637 2.04.637 2.55 0 .217 0 .36-.038.492-.073.256-.288.47-.917 1.1-.219.219-.234.546-.123.925.278.947 1.351 2.216 2.034 2.899.832.831 2.21 2.026 3.157 2.12Zm4.895 5.295c.418-.014.97-.135 1.48-.503a2.588 2.588 0 0 0 1.07-2.132v-2.55c0-1.446-1.17-2.235-1.96-2.518-.36-.13-.938-.259-1.354-.351l-.102-.023c-.542-.121-.939-.213-1.137-.279-1.014-.338-1.875-.008-2.447.378a5.34 5.34 0 0 0-.6.483c-.513-.328-1.112-.859-1.587-1.334-.414-.413-.965-1.052-1.308-1.61a4.15 4.15 0 0 0 .533-.686c.415-.691.408-1.36.405-1.648v-.058c0-.566-.19-1.306-.308-1.746a27.026 27.026 0 0 0-.432-1.435c-.303-.908-1.153-2.005-2.535-2.005H5.326a2.71 2.71 0 0 0-1.567.505 2.588 2.588 0 0 0-1.07 2.132v.035l-.002.088a11.427 11.427 0 0 0 .027 1.108c.049.664.168 1.518.45 2.505.568 1.988 1.774 4.44 4.253 6.918 3.972 3.972 8.586 4.853 10.74 4.726Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}))));
exports.PhoneIcon = PhoneIcon;